export default function () {
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent) && 'ontouchstart' in window) {
    document.body.classList.add('ios-device');
  }
}
